<template>
    <v-container>
        <v-card>
            <v-card-text>
                <h4 class="primary--text">{{$route.params.id?'Edit':'Create'}} User</h4>
                <v-form>
                    <v-text-field type="text" :label="$t('lang.user.username')" v-model.trim="user.userName"
                                  name="userName"
                                  v-validate="'required|alpha_num|max:50|usernameUnique'"
                                  :data-vv-as="$t('lang.user.username')"
                                  maxLength="20" autofocus :disabled="user.userId>0"
                                  :error-messages="errors.first('userName')"
                    ></v-text-field>

                    <v-text-field type="password" ref="password" :label="$t('lang.user.password')"
                                  v-model.trim="user.password"
                                  name="password" v-validate="user.id?'min:8':'min:8'"
                                  :data-vv-as="$t('lang.user.password')"
                                  maxLength="20"
                                  :error-messages="errors.first('password')"
                    ></v-text-field>

<!--                    <v-text-field type="password" :label="$t('lang.user.retypePassword')"-->
<!--                                  v-model.trim="user.passwordConf" name="passwordConf"-->
<!--                                  v-validate="user.id?'confirmed:password':'confirmed:password'"-->
<!--                                  :data-vv-as="$t('lang.user.retypePassword')"-->
<!--                                  ref="passwordConf"-->
<!--                                  :error-messages="errors.first('passwordConf')"-->
<!--                    ></v-text-field>-->

                    <v-text-field type="text" :label="$t('lang.user.email')" v-model.trim="user.email" name="email"
                                  v-validate="user.id?'required|email|emailUnique':'required|email|emailUnique'"
                                  :data-vv-as="$t('lang.user.email')"
                                  maxLength="50"

                                  :error-messages="errors.first('email')"
                    ></v-text-field>

                    <v-text-field type="text" :label="$t('lang.user.fullName')" v-model.trim="user.fullName"
                                  name="fullName"
                                  v-validate="'required'" maxLength="50"
                                  :data-vv-as="$t('lang.user.fullName')"
                                  :error-messages="errors.first('fullName')"
                    ></v-text-field>

                    <!-- <v-text-field type="text" label="Phone*" v-model="user.phone" name="phone" v-validate="'required'" mask="(###) ### - ####" maxLength="20"
                    :error-messages="errors.first('phone')"
                    ></v-text-field> -->

                    <v-text-field type="text" :label="$t('lang.user.phone')" v-model.trim="user.phone" name="phone"
                                  v-validate="{ required: true, regex: /^[0-9()-]*$/im }" maxLength="20"
                                  :data-vv-as="$t('lang.user.phone')"
                                  :error-messages="errors.first('phone')"
                    ></v-text-field>

                    <v-checkbox v-model="user.status" :label="$t('lang.user.status')" name="status" type="checkbox"
                                :data-vv-as="$t('lang.user.status')"
                                :false-value="0"
                                :true-value="1"
                                :error-messages="errors.first('status')"
                    ></v-checkbox>


                    <!--v-select :items="countryIds" :label="$t('lang.user.country')"
                              v-model="user.countryId" name="countryId"
                              item-value="code"
                              item-text="name"
                              v-validate="'required'"
                              :data-vv-as="$t('lang.user.country')"
                              :error-messages="errors.first('countryId')"

                    /-->

                    <v-select :items="roleList" :label="$t('lang.user.role')" v-model="user.role" name="role"
                              item-text="roleName" item-value="id" v-validate="'required'"
                              :data-vv-as="$t('lang.user.role')"
                              @change="onRoleChange"
                              :error-messages="errors.first('role')"
                    />

                    <v-select v-if="isSchoolRole" 
                              :items="provinceUsers" 
                              :label="'Tỉnh/Thành phố'"
                              v-model="user.provinceId" 
                              name="provinceId"
                              item-text="fullName" 
                              item-value="userId" 
                              clearable
                              :data-vv-as="'Tỉnh/Thành phố'"
                              :error-messages="errors.first('provinceId')"
                    />


                    <v-text-field type="text" :label="$t('lang.user.numberClass')" v-model.trim="user.numberClass"
                                  name="numberClass"
                                  v-validate="'regex:^[0-9]+$'"
                                  maxLength="50"
                                  :data-vv-as="$t('lang.user.numberClass')"
                                  :error-messages="errors.first('numberClass')"
                    ></v-text-field>
                  <i-datepicker :label="$t('lang.common.licenseEndDate')"
                                v-validate="'date_after_now'"
                                :data-vv-as="$t('lang.common.licenseEndDate')"
                                name="licenseEndDate"
                                @clearText=""
                                v-model="user.licenseEndDate"
                                value=""
                                clearable
                                :error-messages="errors.first('licenseEndDate')"
                  />

                  <!--                    <v-select :items="lstArea" :label="$t('lang.area.name')" v-model="user.area" name="area"-->
<!--                              item-text="categoryCode" item-value="categoryId"-->
<!--                              multiple-->
<!--                              clearable-->
<!--                              :data-vv-as="$t('lang.area.name')"-->
<!--                              :error-messages="errors.first('area')"-->
<!--                    />-->

<!--                    <v-select :items="lstMaterialType" :label="$t('lang.user.materialType')" v-model="user.materialTypes" name="materiaType"-->
<!--                              item-text="categoryName" item-value="categoryId"-->
<!--                              multiple-->
<!--                              clearable-->
<!--                              :data-vv-as="$t('lang.user.materialType')"-->
<!--                              :error-messages="errors.first('materiaType')"-->
<!--                    />-->
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="handleSubmit">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="error" dark @click="back">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {router} from "../../router";
    import {mapState} from "vuex";
    import {Validator} from "vee-validate";
    import {CrudService} from "@/services";
    import {roleService} from "@/services";
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "UserEdit",
        data() {
            const today = new Date();
            const nextYear = new Date(today.setFullYear(today.getFullYear() + 1))
                .toISOString()
                .substring(0, 10); // YYYY-MM-DD
            const domain = window.location.hostname;
            const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
            return {
                submitted: false,
                lstArea:null,
                lstMaterialType:null,
                user: {
                    status: 1,
                    numberClass: 50,
                    licenseEndDate: nextYear,
                    product: product
                },
                countryIds: [],
                provinceUsers: [],
            };
        },
        computed: {
            ...mapState({
                loading: state => state.common.loading,
                roleList: state => state.role.roleList.filter(function (value) {
                    return value.active == 1;
                })
            }),
            isSchoolRole() {
                // Role ID 43 là school role
                let currentProduct = window.location.hostname.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
                if(currentProduct === 'EDUSMART') {
                     return this.user.role === 127;
                } else {
                     return this.user.role === 43;
                }
            }
        },
        methods: {
            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByType?type=PONDAREA"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea = data;
                        }
                    }
                );
            },

            getMaterialType() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstMaterialType = data;
                        }
                    }
                );
            },

            handleSubmit(e) {
                this.submitted = true;
                

                this.$validator.validate().then(valid => {
                    if (valid) {
                        // if(this.user.area != null) {
                        //     this.user.area = JSON.stringify(this.user.area);
                        // }
                        // if(this.user.materialTypes != null) {
                        //     this.user.materialType = JSON.stringify(this.user.materialTypes);
                        // }
                        if (this.$route.params.id) {
                            CrudService.of('user').updateItem(this.user).then(() => {
                                message.success(`Update User Success!`, '/user/list');
                            });
                        } else {
                            CrudService.of('user').createItem(this.user).then(() => {
                                message.success(`Create User Success!`, '/user/list');
                            });
                        }
                    }
                });
                return false;
            },
            back() {
                router.push("/user/list");
            },
            onRoleChange() {
                // Reset provinceId khi đổi role
                if (!this.isSchoolRole) {
                    this.user.provinceId = null;
                }
            },
            loadProvinceUsers() {
                const domain = window.location.hostname;
                const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
                axios.get(`${process.env.VUE_APP_API_URL}/user/provinces?product=${product}`)
                    .then(response => {
                        // Interceptor đã trả về response.data, nên response ở đây đã là data array
                        this.provinceUsers = Array.isArray(response) ? response : [];
                        console.log('Province users loaded:', this.provinceUsers);
                    })
                    .catch(error => {
                        console.error('Error loading province users:', error);
                        this.provinceUsers = [];
                    });
            }
        },
        created() {
            this.$store.dispatch("role/getRoleList");
            this.loadProvinceUsers();
            if (this.$route.params.id) {
                CrudService.of('user').getItem(this.$route.params.id).then(user => {
                    user.password = "";
                    //debugger;
                    let userTmp = JSON.parse(
                        localStorage.getItem("user") === "undefined"
                            ? null
                            : localStorage.getItem("user")
                    );
                    if (userTmp.username != "admin" && user.username == "admin") {
                        message.error("Can not modify admin account!");
                        router.push("/user/list");
                    }
                    this.user = user;
                    // if(this.user.area != undefined && this.user.area != null && this.user.area != "") {
                    //     this.user.area = JSON.parse(this.user.area);
                    // }
                    // if(this.user.materialType != undefined && this.user.materialType != null && this.user.materialType != "") {
                    //     this.user.materialTypes = JSON.parse(this.user.materialType);
                    // }
                    this.initUsername = user.userName;
                    this.initEmail = user.email;
                });

            }
            // this.getArea();
            // this.getMaterialType();
        },
        mounted() {
            let me = this;
            const domain = window.location.hostname;
            const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
            const usernameUnique = (value) => {
                if (me.initUsername == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-username?username=${value}&product=${product}`).then((data) => {
                    //debugger;
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });

            };

            const emailUnique = (value) => {
                if (me.initEmail == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-email?email=${value}&product=${product}`).then((data) => {
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });
            };

            Validator.extend("usernameUnique", {
                validate: usernameUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.usernameExist');
                }
            });

            Validator.extend("emailUnique", {
                validate: emailUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.emailExist');
                }
            });

/*
            if (this.$route.params.id) {
                this.$refs.password.focus();
            }
*/
        }
    };
</script>
